
import React from 'react';
import { createDefaultFieldFactory, FieldTypes, Form} from '@sitecore-jss/sitecore-jss-react-forms';
import { withRouter } from 'next/router';
import EmailComponent from 'components/CustomContactUsForm/EmailComponent';
import { sitecoreApiKey } from 'temp/config';

const SubscriptionForm = ({ fields }: any) => {
  const defaultFieldFactory = createDefaultFieldFactory();

  //Functions
  defaultFieldFactory.setComponent(FieldTypes.Email, (props: any): any => {
    let tempProps={...props,contactus:false}
    return(
      <EmailComponent {...tempProps} />
    )
  })
  const fieldvalidation = (props: any) => {
    return (
      <div className='mb-4'>
        {props.formErrors}
      </div>
    )

  }
  return (
    <>
      <section
        className={`py-20 bg-card-theme-color text-theme-color xl:py-40 `}
      >
        <div className="flex flex-col lg:max-w-4xl responsive gap-y-5">
          <Form
            form={fields}
            sitecoreApiHost={""}
            sitecoreApiKey={sitecoreApiKey}
            fieldFactory={defaultFieldFactory}
            errorComponent={fieldvalidation}
          />
        </div>
      </section>

    </>

  );
}

export default withRouter(SubscriptionForm);